const { CrudModel } = require('./crud');

export class InhouseProfessionalModel extends CrudModel {
	constructor() {
		super('admin/inhouse_professional', [
			{ key: "deletionReason", name: "Justificativa", kind: "select", options: [
				{ name: "Funcionário desligado", value: "Funcionário desligado" },
				{ name: "Cadastro incorreto", value: "Cadastro incorreto" },
				{ name: "Cadastro duplicado", value: "Cadastro duplicado" },
				{ name: "Outra (descrição abaixo)", value: "Outra (descrição abaixo)" },
			]},
		]);
	}
}

export default new InhouseProfessionalModel();
